export const EXPORT_FORMATS = ["pdf", "xlsx", "csv"] as const;

export type ExportFormat = (typeof EXPORT_FORMATS)[number];

export const XLSX_LAYOUTS = ["consolidado", "abas"] as const;

export type XlsxLayout = (typeof XLSX_LAYOUTS)[number];

export interface XlsxLayoutDetail {
  value: XlsxLayout;
  label: string;
  description: string;
}

/** Organização do XLSX do detalhamento da embarcação. */
export const XLSX_LAYOUT_DETAILS: XlsxLayoutDetail[] = [
  {
    value: "consolidado",
    label: "Dados Consolidados",
    description: "Todas as seções em uma aba",
  },
  {
    value: "abas",
    label: "Separar por abas",
    description: "Uma aba para cada seção",
  },
];

export interface FileExportOptions {
  xlsxLayout?: XlsxLayout;
}

export interface ExportFormatDetail {
  value: ExportFormat;
  label: string;
  description: string;
  extension: string;
  mimeType: string;
  icon: string;
}

/**
 * Arquivo gerado pelo serviço de exportação da listagem (US 1442): o front só
 * entrega o download, sem montar o conteúdo.
 */
export interface ExportedFile {
  content: Uint8Array;
  /** Nome indicado pelo serviço em `Content-Disposition`, quando houver. */
  fileName: string | null;
  mimeType: string | null;
}

const PDF_FORMAT_DETAIL: ExportFormatDetail = {
  value: "pdf",
  label: "PDF",
  description: "Formato .pdf",
  extension: "pdf",
  mimeType: "application/pdf",
  icon: "pi pi-file-pdf",
};

/** Seção "Selecione o formato de saída" do modal Exportar Tabela (RN002). */
export const EXPORT_FORMAT_DETAILS: ExportFormatDetail[] = [
  PDF_FORMAT_DETAIL,
  {
    value: "xlsx",
    label: "Planilha Excel",
    description: "Formato .xlsx",
    extension: "xlsx",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    icon: "pi pi-table",
  },
  {
    value: "csv",
    label: "Texto Separado",
    description: "Formato .csv",
    extension: "csv",
    mimeType: "text/csv;charset=utf-8",
    icon: "pi pi-file",
  },
];

export function isExportFormat(value: string): value is ExportFormat {
  return EXPORT_FORMATS.some((format) => format === value);
}

export function findExportFormatDetail(format: ExportFormat): ExportFormatDetail {
  return EXPORT_FORMAT_DETAILS.find((detail) => detail.value === format) ?? PDF_FORMAT_DETAIL;
}
